import { render, staticRenderFns } from "./StudyConversationMessageProfileName.vue?vue&type=template&id=32b26d86&scoped=true"
import script from "./StudyConversationMessageProfileName.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessageProfileName.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessageProfileName.vue?vue&type=style&index=0&id=32b26d86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b26d86",
  null
  
)

export default component.exports